import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { apiResponseMessage } from "redux/actions/ApiMessageResponse";
import { MESSAGE_TYPE } from "redux/constants/ApiMessageResponse";

const ProtectedExternalTradeRoute = ({ children, ...reset }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const intl = useIntl();

  const { token, isPaid, subscripitionExpiryDate } = useSelector(
    ({ auth }) => auth
  );
  const isAuthenticated = () => {
    var result =
      token !== "" && token !== undefined && token !== null ? true : false;
    if (!result) {
      dispatch(
        apiResponseMessage({
          showMessage: true,
          message: intl.formatMessage({ id: "please-sign-in" }),
          messageType: MESSAGE_TYPE.ERROR,
        })
      );
    }
    return result;
    // return true;
  };

  if (!isAuthenticated()) {
    const prevUrl =
      location && location?.pathname
        ? location?.pathname
        : typeof window !== "undefined" && window?.location?.pathname
        ? window?.location?.pathname
        : "/";
    return <Navigate to={`/login`} state={{ prevUrl }} replace />;
  }

  if (
    isPaid &&
    subscripitionExpiryDate &&
    subscripitionExpiryDate?.slice(0, 10) > new Date().toJSON().slice(0, 10)
  ) {
    return <>{children}</>;
  }

  return <Navigate to={`/external-trade-paid`} replace />;
};

export default ProtectedExternalTradeRoute;
